import { Endpoint } from '../endpoint';
import {
  TaskResponse,
  TaskId,
  TaskOrderRequest,
  TodoTasksRequest,
  TodoTasksResponse,
  TodoTaskStatus,
  FetchTaskCountResponse,
  TaskTextSearchResponse,
} from '@business/entities/task';
import { UserId } from '@business/entities/account';
import { TeamId } from '@business/entities/team';
import { R } from '@core/utils/r';
import { OrgId } from '@business/entities/organization';

export function fetchTasks(orgId?: OrgId) {
  return Endpoint.get<TaskResponse[]>(`@gc/task`, { params: R.objectCompact({ orgId }) });
}

export function fetchTodoTasks(params: TodoTasksRequest) {
  return Endpoint.get<TodoTasksResponse>(`@gc/task/todo-tasks`, { params });
}

export function fetchTaskCount(params: { status: TodoTaskStatus }) {
  return Endpoint.get<FetchTaskCountResponse>(`@gc/task/task-count`, { params });
}

export function fetchTask(id: TaskId) {
  return Endpoint.get<TaskResponse>(`@gc/task/task/${id}`);
}

export function createTask(data: Partial<TaskResponse>, parentId?: TaskId) {
  data = { ...data, parentId };
  return Endpoint.post<TaskResponse>(`@gc/task`, { data });
}

export function updateTask(id: TaskId, data: Partial<TaskResponse>) {
  return Endpoint.patch<TaskResponse>(`@gc/task/task/${id}`, { data });
}

export function deleteTask(TaskId: TaskId) {
  return Endpoint.delete<void>(`@gc/task/${TaskId}`);
}

export function setOrders(orders: TaskOrderRequest) {
  return Endpoint.patch<void>(`@gc/task/orders`, { data: { orders } });
}

export function setComplete(id: TaskId, isCompleted: boolean) {
  return Endpoint.patch<TaskResponse>(`@gc/task/complete/${id}`, { data: { isCompleted } });
}

export function search(id: UserId) {
  return Endpoint.get<TaskResponse[]>(`@gc/task/search`, { params: { id } });
}

export function textSearch(query: string, params: TodoTasksRequest) {
  return Endpoint.get<TaskTextSearchResponse>(`@gc/task/text-search`, { params: { query, ...params } });
}
